/* build/tpl */
import deps from './deps/pathMatches.js';
import getPathMatches from './getPathMatches.js';
export default getPathMatches(deps);
